import { createRouter, createWebHistory } from "vue-router";
import LoginForm from "./components/LoginForm.vue";
import JobsList from "./components/JobsList.vue";
import ParseOffer from "./components/offers/ParseOffer.vue";
import CaptureOffer from "./components/offers/CaptureOffer.vue";
import ProfileForm from "./components/ProfileForm.vue";
import OffersList from "./components/offers/OffersList.vue";
import MyOffersList from "./components/offers/MyOffersList.vue";
import AcquisitionItemsWorkspace from "./components/offers/AcquisitionItemsWorkspace.vue";
import ItemsList from "./components/items/ItemsList.vue";
import DashboardMain from "./components/DashboardMain.vue";
import SalesList from "./components/sales/SalesList.vue";
import NotificationsSettings from "./components/NotificationsSettings.vue";
import WatchPage from "./components/watch/WatchPage.vue";
import PackagesList from "./components/packages/PackagesList.vue";
import PackageEditor from "./components/packages/PackageEditor.vue";

const routes = [
  {
    path: "/",
    component: LoginForm,
    meta: { showSidebar: false, title: "Collection" },
  },
  {
    path: "/dashboard",
    component: DashboardMain,
    meta: {
      showSidebar: true,
      title: "Tableau de bord - Collection",
      section: "Aujourd’hui",
    },
  },
  {
    path: "/jobs",
    component: JobsList,
    meta: {
      showSidebar: true,
      title: "Échéances - Collection",
      section: "Aujourd’hui",
    },
  },
  {
    path: "/offers",
    component: OffersList,
    meta: {
      showSidebar: true,
      title: "Annonces suivies - Collection",
      section: "Acquisitions",
    },
  },
  {
    path: "/myoffers",
    name: "acquisitions",
    component: MyOffersList,
    meta: {
      showSidebar: true,
      title: "Achats et lots - Collection",
      section: "Acquisitions",
    },
  },
  {
    path: "/myoffers/:offerId/items",
    name: "acquisition-items",
    component: AcquisitionItemsWorkspace,
    meta: {
      showSidebar: true,
      title: "Gérer les objets - Collection",
      section: "Acquisitions",
    },
  },
  {
    path: "/parse",
    component: ParseOffer,
    meta: {
      showSidebar: true,
      title: "Suivre une annonce - Collection",
      section: "Acquisitions",
    },
  },
  {
    path: "/capture",
    name: "capture-offer",
    component: CaptureOffer,
    meta: { showSidebar: false, title: "Ajout express - Prexens" },
  },
  {
    path: "/profile",
    component: ProfileForm,
    meta: {
      showSidebar: true,
      title: "Mon espace - Collection",
      section: "Mon compte",
    },
  },
  {
    path: "/items",
    name: "items",
    component: ItemsList,
    meta: {
      showSidebar: true,
      title: "Collection - Collection",
      section: "Inventaire",
    },
  },
  {
    path: "/packages",
    name: "packages",
    component: PackagesList,
    meta: {
      showSidebar: true,
      title: "Colis - Collection",
      section: "Acquisitions",
    },
  },
  {
    path: "/packages/:packageId",
    name: "package",
    component: PackageEditor,
    meta: {
      showSidebar: true,
      title: "Colis - Collection",
      section: "Acquisitions",
    },
  },
  {
    path: "/veille",
    name: "veille",
    component: WatchPage,
    meta: {
      showSidebar: true,
      title: "Veille - Collection",
      section: "Acquisitions",
    },
  },
  {
    path: "/notifications",
    name: "notifications",
    component: NotificationsSettings,
    meta: {
      showSidebar: true,
      title: "Notifications - Collection",
      section: "Réglages",
    },
  },
  {
    path: "/sales",
    name: "sales",
    component: SalesList,
    meta: {
      showSidebar: true,
      title: "Ventes - Collection",
      section: "Inventaire",
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
